import { render } from "./FriendLinks.vue?vue&type=template&id=3402e950&scoped=true"
import script from "./FriendLinks.vue?vue&type=script&lang=js"
export * from "./FriendLinks.vue?vue&type=script&lang=js"

import "./FriendLinks.vue?vue&type=style&index=0&id=3402e950&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3402e950"]])

export default __exports__